import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})

export class UtcToLocalPipe implements PipeTransform {

  transform(value: string | null): Date | null {
    if (!value) return null; 

    const isoDateString = value.replace(' ', 'T') + 'Z';
    return new Date(isoDateString);
  }
}
